
const getCookie = (name) => {
  const cookie = document.cookie
    .split("; ")
    .find((item) => item.startsWith(`${name}=`));

  return cookie ? cookie.substring(name.length + 1) : undefined;
};

const sendMetaEvent = (eventName) => {
  const eventId = `event-${crypto.randomUUID()}`;

  const fbp = getCookie("_fbp");
  const fbc = getCookie("_fbc");

  // Browser Pixel event
  if (typeof window.fbq === "function") {
    window.fbq(
      "trackCustom",
      eventName,
      {},
      { eventID: eventId }
    );
  }

  // Server-side Conversions API event
  fetch("/.netlify/functions/meta-capi", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      eventName,
      eventId,
      fbp,
      fbc,
      eventSourceUrl: window.location.href,
    }),
  }).catch((error) => {
    console.error("Meta CAPI event failed:", error);
  });
};

export default sendMetaEvent;
